// extracted by mini-css-extract-plugin
export var chevron = "_id-2";
export var dropdownItems = "_id-0";
export var item = "_id-1";